import(/* webpackMode: "eager" */ "/monorepo/dojo/src/app/template.tsx");
